var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error',{attrs:{"code":405,"text":'Данное действие недоступно.'}})}
var staticRenderFns = []

export { render, staticRenderFns }